import React, {
  useState,
  useEffect
} from 'react'
import { domToReact } from 'html-react-parser'
import {
  Form,
  Radio,
  Checkbox 
} from 'antd';
import { OrderImages } from './surveyanswers-orderimages'

export const SurveyAnswersGroup = props => { 

  const form = Form.useFormInstance()
  const [ formContext, setFormContext ] = useState() 

  const required = props.parent.attribs['data-required'] == 'true'

  const children = domToReact(
    props.children, 
    { 
      replace: props.replace
    }
  )
  
  useEffect(() => {

    if(form) {
      
      setFormContext(form)
    }

  }, [form])

  let Field

  switch(props.parent.attribs['data-type']) {

    case 'uniq':

      Field = <Form.Item
        name={props.parent.attribs['data-blockid']}
        rules={[{ required: required, message: "Este campo es obligatorio" }]}
      >
        <Radio.Group 
          disabled={ formContext?.eventData?.instance.closed }
        >
          { children }
        </Radio.Group>
      </Form.Item>

      break

    case 'multiple':

      Field = <Form.Item
        name={props.parent.attribs['data-blockid']}
        rules={[{ required: required, message: "Este campo es obligatorio" }]}
      >
        <Checkbox.Group 
          disabled={ formContext?.eventData?.instance.closed }
        >
          { children }
        </Checkbox.Group>
      </Form.Item>

      break

    case 'orderimages':

      Field = <OrderImages { ...props }/>

      break

    default:

      Field = <div>No Type</div>

      break
  }

  return Field
}
